const env = import.meta.env || {};

console.info({ env });
export const locales = [
  {
    id: "en-CA",
    title: "English",
    timezone: "America/New_York",
    formats: {
      shortDate: "MM/DD",
      shortTime: "h:mma",
    },
  },
  {
    id: "fr-CA",
    title: "French",
    timezone: "America/New_York",
    formats: {
      shortDate: "MM/DD",
      shortTime: "h:mma",
    },
  },
];

export const defaultLocale = "en-CA";

export const socialLinks = [
  {
    title: "Instagram",
    url: "https://www.instagram.com/clubhrewards",
  },
  {
    title: "TiKTok",
    url: "https://www.tiktok.com/clubhrewards",
  },
  {
    title: "Facebook",
    url: "https://www.facebook.com/clubhrewards",
  },
  {
    title: "YouTube",
    url: "https://www.youtube.com/@ClubHrewards",
  },
];

export const environment = env.MODE;
export const isLocalEnv = env.MODE == null || env.MODE === "development";

export const isMasterEnv = env.MODE === "master";

export const isStagingEnv = env.MODE === "staging";

export const isHostedEnv = isMasterEnv || isStagingEnv;

export const isSSR = env.SSR;

export const isBrowser = isSSR === false;

export const helmetConfig = {
  defaultTitle: "Club H Rewards: Loyalty for Life",
  titleTemplate: "%s - Club H Rewards: Loyalty for Life",
};

export const apiDomain = env.VITE_API_DOMAIN;

export const apiSiteId = env.VITE_API_SITEID;

export const frontendDomain = env.VITE_FRONTEND_DOMAIN;

export const provinces = [
  {
    label: "Alberta",
    value: "AB",
  },
  {
    label: "British Columbia",
    value: "BC",
  },
  {
    label: "Manitoba",
    value: "MB",
  },
  {
    label: "New Brunswick",
    value: "NB",
  },
  {
    label: "Newfoundland and Labrador",
    value: "NL",
  },
  {
    label: "Nova Scotia",
    value: "NS",
  },
  {
    label: "Northwest Territories",
    value: "NT",
  },
  {
    label: "Nunavut",
    value: "NU",
  },
  {
    label: "Ontario",
    value: "ON",
  },
  {
    label: "Prince Edward Island",
    value: "PE",
  },
  {
    label: "Quebec",
    value: "QC",
  },
  {
    label: "Saskatchewan",
    value: "SK",
  },
  {
    label: "Yukon",
    value: "YT",
  },
];

// Registration form distributor list - excludes Cosmoprof and Beauté Star
// These are the distributors that should appear on the Club H registration form
export const registrationDistributorsList = [
  { label: "CanRad Beauty", value: "652c232cd8ba7f013db7b0f9" },
  { label: "Capilex", value: "657b3503042c184a9bca613a" },
  { label: "Central Beauty Supply", value: "652c2354d8ba7f013db7b129" },
  { label: "Chalut", value: "65491ac5042c184a9bc2263d" },
  { label: "Henkel Direct Sales", value: "6525b84b85b23b704a2d18c3" },
  { label: "Jean Julien", value: "654d11cf042c184a9bc55850" },
  { label: "Maritime Beauty", value: "652c4ba4f14850a617bad730" },
  { label: "Modern Beauty Supplies", value: "652c15bed8ba7f013db78ba6" },
  { label: "Radiant Beauty Supplies", value: "652c2346d8ba7f013db7b119" },
  { label: "Salon Centre (SK/MB)", value: "654d1959042c184a9bc5ad8b" },
  { label: "West Coast Beauty", value: "654d0459042c184a9bc49fb1" },
  { label: "Windsor Beauty Supply", value: "65524f37042c184a9bc7b303" },
];

// Education request form distributor list - includes all distributors including Cosmoprof and Beauté Star
export const educationDistributorsList = [
  { label: "Beauté Star", value: "65cba01448950591c41b0ca8" },
  { label: "CanRad Beauty", value: "652c232cd8ba7f013db7b0f9" },
  { label: "Capilex", value: "657b3503042c184a9bca613a" },
  { label: "Central Beauty Supply", value: "652c2354d8ba7f013db7b129" },
  { label: "Chalut", value: "65491ac5042c184a9bc2263d" },
  { label: "Cosmoprof", value: "692dcdf2a2e0d055c171fe98" },
  { label: "Henkel Direct Sales", value: "6525b84b85b23b704a2d18c3" },
  { label: "Jean Julien", value: "654d11cf042c184a9bc55850" },
  { label: "Maritime Beauty", value: "652c4ba4f14850a617bad730" },
  { label: "Modern Beauty Supplies", value: "652c15bed8ba7f013db78ba6" },
  { label: "Radiant Beauty Supplies", value: "652c2346d8ba7f013db7b119" },
  { label: "Salon Centre (SK/MB)", value: "654d1959042c184a9bc5ad8b" },
  { label: "West Coast Beauty", value: "654d0459042c184a9bc49fb1" },
  { label: "Windsor Beauty Supply", value: "65524f37042c184a9bc7b303" },
];

// Getter functions for each context
export const getRegistrationDistributors = () => registrationDistributorsList;
export const getEducationDistributors = () => educationDistributorsList;

// Legacy exports - defaults to registration list for backward compatibility
export const distributorsList = registrationDistributorsList;
export const distributors = () => registrationDistributorsList;
export const getDistributors = () => Promise.resolve(registrationDistributorsList);
